import targetTranslations from './targetTranslations';

export const TEXT_ITEMS = targetTranslations.map(translation => translation.label);



// WEBPACK FOOTER //
// ./src/languageData/constants/textItems.js